<template>
  <v-dialog v-model="showDialog" width="500" persistent>
    <v-card class="pa-4">
      <v-card-title class="ma-0 mb-2 pa-0">
        <h2>Fields Not in Schema</h2>
      </v-card-title>
      <v-card-text class="ma-0 mt-2 mb-1 pa-0">
        <p>
          The following fields in this case are not defined in the current schema:
        </p>
        <ul class="mt-2 mb-3">
          <li v-for="field in invalidFields" :key="field" class="mb-1">
            <strong>{{ field }}</strong>
          </li>
        </ul>
        <p>
          If you proceed with saving, the data in these fields will be permanently lost.
        </p>
      </v-card-text>
      <v-card-actions class="ma-0 mt-3 pa-0">
        <v-btn
          @click="proceed()"
          id="invalid-fields-dialog-proceed-btn"
          color="error"
        >
          Yes, proceed and remove these fields
        </v-btn>
        <v-btn
          @click="cancel()"
          id="invalid-fields-dialog-cancel-btn"
          color="secondary"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "InvalidFieldsDialog",
  computed: {
    ...mapState({
      invalidFieldsDialog: state => state.cases.invalidFieldsDialog
    }),
    showDialog() {
      return this.invalidFieldsDialog.show
    },
    invalidFields() {
      return this.invalidFieldsDialog.invalidFields || []
    }
  },
  methods: {
    proceed() {
      const caseData = this.invalidFieldsDialog.pendingCaseData
      if (caseData) {
        this.$store.dispatch("updateCaseWithForce", caseData)
      }
    },
    cancel() {
      this.$store.commit("hideInvalidFieldsDialog")
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 20px;
}
li {
  list-style-type: disc;
}
</style>
